import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import MarketingPage from './pages/MarketingPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardHome from './components/Dashboard/DashboardHome';
import PreloadSection from './components/Dashboard/PreloadSection';
import ReportsSection from './components/Dashboard/ReportsSection';
import HistorySection from './components/Dashboard/HistorySection';
import UsersSection from './components/Dashboard/UsersSection';
import AccountSection from './components/Dashboard/AccountSection';
import LicensesSection from './components/Dashboard/LicensesSection';
import ScanningSession from './components/Dashboard/ScanningSession';
import ScanningSessionDetail from './components/Dashboard/ScanningSessionDetail';

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<MarketingPage />} />
                    <Route
                        path="/dashboard/*"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<DashboardHome />} /> {/* Default subpage */}
                        <Route path="home" element={<DashboardHome />} />
                        <Route path="preload" element={<PreloadSection />} />
                        <Route path="scanning-session" element={<ScanningSession />} />
                        <Route path="scanning-session/:id" element={<ScanningSessionDetail />} />
                        {/* <Route path="reports" element={<ReportsSection />} /> */}
                        {/* <Route path="history" element={<HistorySection />} /> */}
                        <Route path="users" element={<UsersSection />} />
                        <Route path="licenses" element={<LicensesSection />} />
                        <Route path="account" element={<AccountSection />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;